import React, { useState } from "react";
import AcordeonText from "./acordeonText/acordeon";
import AcordeonList from "./acordeonList/acordeon";
import AcordeonListTwo from "./acordeonList/acordeonListTwo";
import TitleCard from "./texts/titleCard";
import Title from "./texts/headline";
import Body from "./texts/body";
import "./accordeon.css";

const Accordeon = () => {
  const dataAccordeon = [
    {
      Titulo: "企业税务服务",
      Texto: [
        "企业税务咨询",
        "企业常年税务顾问",
        "企业并购重组税务服务",
        "企业涉税筹划方案设计",
        "出口退税服务",
        "企业发票代开服务（到指定的税务机关）",
        "企业注册、变更、注销服务",
        "税务合规及申报服务",
        "税收培训服务",
      ],
    },
    {
      Titulo: "企业税收风险识别及管控",
      Texto: [
        "企业税收风险识别及管控",
        "企业涉税稽查应对",
        "企业税务争议服务",
        "企业全税种全流程纳税风险管理",
      ],
    },
    {
      Titulo: "税务合规性审核",
      Texto: [
        "企业所得税汇算清缴纳税申报审核",
        "各种税收优惠备案审核",
        "IPO 项目税务审核",
        "企业注销税款清算审核",
        "其他税务合规性审核业务",
      ],
    },
    {
      Titulo: "国际税收服务",
      Texto: [
        "海外上市税务审核",
        "税收协定咨询",
        "国际税务合规及申报服务",
        "国际并购税务服务",
        "全球贸易税务服务",
        "海外账户纳税方案",
        "外资企业税务咨询及相关服务",
        "外籍个人税务咨询及相关服务",
      ],
    },
    {
      Titulo: "转让定价",
      Texto: [
        "转让定价申报",
        "转让定价咨询",
        "同期资料准备",
        "预约定价",
        "TP 稽查应对",
        "其他转让定价服务 ",
        "转让定价咨询及同期资料准备",
        "避免争议：预约定价安排",
        "税务沟通与协调：调查抗辩和相互协商程序/相应调整（MAP/CA）",
      ],
    },
    {
      Titulo: "涉税交易支持",
      Texto: [
        "资本运作涉税支持",
        "税务尽职调查",
        "进出口涉税支持服务",
        "涉外交易支持",
      ],
    },
    {
      Titulo: "个人税务服务",
      Texto: [
        "个税申报的代理服务",
        "个税缓税申请的代理服务",
        "个税纳税筹划服务",
      ],
    },
  ];
  const dataAccordeonDos = [
    {
      Titulo: "财务会计服务",
      Texto: [
        "财务架构设计及风险管控",
        "复杂的会计处理咨询",
        "会计支持",
        "代理记账服务（双语）",
      ],
    },
    {
      Titulo: "并购交易服务",
      Texto: [
        "财务与税务尽职调查",
        "买卖协议会计建议",
        "卖方尽职调查/协助",
      ],
    },
    {
      Titulo: "项目咨询服务",
      Texto: [
        "IPO 上市可行性评估",
        "IPO 境外上市报表及报告语言转换服务",
        "交易咨询",
        "并购项目支援",
      ],
    },
  ];
  const dataAccordeonTres = [
    {
      Titulo: "政府协调",
      Texto: [
        "政策申请",
        "协助企业与地方政府协商， 申请财政扶持政策",
        "财政扶持业务的代理",
      ],
    },
    {
      Titulo: "代理服务",
      Texto: [
        "代办税收困难减免服务",
        "企业工商及税务服务",
        "对外付汇服务",
        "各类税务优惠申请及备案服务",
        "高新技术代理服务T"
      ],
    },
    
  ];
  return (
    <>
      <div className="content_faqs">
        <div className="FAQsBox">
          <div className="accordeonTitleContainer">
            <div className="acordeonDivider"></div>
            <TitleCard value="税务" styleClass="accordeonTitle" />
            <div className="acordeonDivider"></div>
          </div>
          <div className="boxFaqsAcordeon">
            <AcordeonText valor={dataAccordeon} />
          </div>
        </div>
        <div className="FAQsBox">
          <div className="accordeonTitleContainer">
            <div className="acordeonDivider"></div>
            <TitleCard
              value="财务服务"
              styleClass="accordeonTitle"
            />
            <div className="acordeonDivider"></div>
          </div>
          <div className="boxFaqsAcordeon">
            <AcordeonText valor={dataAccordeonDos} />
          </div>
        </div>
        <div className="FAQsBox">
          <div className="accordeonTitleContainer">
            <div className="acordeonDivider"></div>
            <TitleCard
              value="其他合规性服务"
              styleClass="accordeonTitle"
            />
            <div className="acordeonDivider"></div>
          </div>
          <div className="boxFaqsAcordeon">
            <AcordeonText valor={dataAccordeonTres} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Accordeon;
